import { render, staticRenderFns } from "./CalendarIconNew.vue?vue&type=template&id=11e53358"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11e53358')) {
      api.createRecord('11e53358', component.options)
    } else {
      api.reload('11e53358', component.options)
    }
    module.hot.accept("./CalendarIconNew.vue?vue&type=template&id=11e53358", function () {
      api.rerender('11e53358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CalendarIconNew.vue"
export default component.exports